import {
  ChevronLeft, Filter, Minus, Plus,
} from 'react-feather';

import {
  default as Copy,
  default as CopyBlue,
} from 'assets/img/icons/copy.svg';
import ThreeDots from 'assets/img/icons/moreHorizontal.svg';
import Setting from 'assets/img/icons/settings.svg';
import Edit from 'assets/img/icons/edit-icon.svg';
import Prefill from 'assets/img/icons/paint.svg';
import Trash from 'assets/img/icons/trash.svg';
import Play from 'assets/img/icons/play.png';

import IconCustom from 'components/_parts/atoms/icon';

type BtnProps = {
  className?: string;
  style?: React.CSSProperties;
  // style?: HTMLAttributes<HTMLDivElement>;
  disabled?: boolean;
  func?: () => void;
  icon?: keyof typeof iconType;
  // children?: ReactPortal
  children?: React.ReactNode
};

const iconType = {
  create: <Plus size={12} style={{ strokeWidth: '3.4' }} />,
  minus: <Minus size={12} style={{ strokeWidth: '3.4' }} />,
  back: <ChevronLeft size={15} />,
  edit: <img src={Edit} alt="edit-icon" style={{ display: 'block', width: '14px', height: '14px' }} />,
  filter: <Filter size={12} style={{ strokeWidth: '3.4' }} />,
  '3dots': <img src={ThreeDots} alt="3dots icon" />,
  delete: <img src={Trash} alt="trash icon" />,
  prefill: <img src={Prefill} alt="prefill icon" />,
  setting: <img src={Setting} alt="setting icon" />,
  copy: <img src={Copy} alt="copy icon" />,
  copyBlue: <img src={CopyBlue} alt="copy icon" />,
  loading: <IconCustom typeIcon="loading" />,
  print: <IconCustom typeIcon="print" />,
  check_circle: <IconCustom typeIcon="check_circle" />,
  next: <IconCustom typeIcon="chevronsUp" />,
  prev: <IconCustom typeIcon="chevronsDown" />,
  down: <IconCustom typeIcon="down" />,
  chevronRight: <IconCustom typeIcon="chevronRight" />,
  eye: <IconCustom typeIcon="eye" />,
  bookOpen: <IconCustom typeIcon="bookOpen" style={{ color: '#4C4C4C' }} />,
  magicWind: <IconCustom typeIcon="magicWind" style={{ color: '#fff', width: '14px', height: '14px' }} />,
  play: <img src={Play} alt="play icon" width={14} height={14} />,
  default: '',
} as const;

function Index({ ...props }: Readonly<BtnProps>) {
  const iconElement = props?.icon && iconType[props.icon] ? iconType[props.icon] : null;
  return (
    <div
      id="button-custom"
      className={`btn_custom ${props?.className}`}
      style={{
        ...props?.style,
        cursor: props?.disabled ? 'not-allowed' : 'pointer',
        pointerEvents: props?.disabled ? 'none' : 'auto',
      }}
      onClick={() => {
        if (props?.func) {
          props?.func();
        }
      }}
      aria-hidden="true"
    >
      {iconElement}
      {props?.children}
    </div>
  );
}

export default Index;
